"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.basicRegisterFieldsNames = void 0;
exports.buildInjectToForm = buildInjectToForm;
exports.default = void 0;
var _core = require("@material-ui/core");
var _Button = _interopRequireDefault(require("@material-ui/core/Button"));
var _react = _interopRequireDefault(require("react"));
var _BaseForm = _interopRequireDefault(require("react-platform-components/dist/BaseComponents/BaseForm"));
var _BaseInjectors = require("react-platform-components/dist/BaseComponents/BaseInjectors");
var _formFields = require("react-platform-components/dist/form-fields");
var _formValidators = require("react-platform-components/dist/form-validators");
var _Translations = require("react-platform-components/dist/Translations");
var _reactRouterDom = require("react-router-dom");
var _config = require("../config");
var _lodash = _interopRequireDefault(require("lodash"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var SocialAuthButtons = null;
try {
  SocialAuthButtons = require('react-platform-social/dist/SocialAuth/SocialAuthButtons').default;
} catch (error) {
  console.warn('SocialAuthButtons not found');
}
var basicRegisterFieldsNames = ['first_name', 'last_name', 'email', 'password', 'accept', 'confirm_password', 'phone'];

// Register form fields
exports.basicRegisterFieldsNames = basicRegisterFieldsNames;
var getFormExtraFields = function getFormExtraFields(props, embeded) {
  var isSafari = /constructor/i.test(window.HTMLElement) || function (p) {
    return p.toString() === "[object SafariRemoteNotification]";
  }(!window['safari'] || typeof safari !== 'undefined' && window['safari'].pushNotification);
  var formExtraFields = [/*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_core.Grid, {
    container: true,
    spacing: 2
  }, /*#__PURE__*/_react.default.createElement(_core.Grid, {
    item: true,
    xs: 12,
    sm: 12
  }, _config.DISPLAY_SAFARI_LOREM && isSafari && /*#__PURE__*/_react.default.createElement(_core.Typography, {
    color: "error"
  }, /*#__PURE__*/_react.default.createElement(_Translations.IntlMessages, {
    id: "Oups il semblerait que vous utilisiez le navigateur Safari. Notre plateforme est optimis\xE9e pour les navigateurs Chrome et Firefox",
    defaultMessage: "Oups il semblerait que vous utilisiez le navigateur Safari. Notre plateforme est optimis\xE9e pour les navigateurs Chrome et Firefox"
  }))), /*#__PURE__*/_react.default.createElement(_core.Grid, {
    item: true,
    xs: 12,
    sm: 6
  }, /*#__PURE__*/_react.default.createElement(_formFields.TextField, {
    autoComplete: "fname",
    name: "first_name",
    variant: "outlined",
    required: true,
    fullWidth: true,
    id: "firstName",
    label: "First Name",
    validate: (0, _formValidators.required)()
  })), /*#__PURE__*/_react.default.createElement(_core.Grid, {
    item: true,
    xs: 12,
    sm: 6
  }, /*#__PURE__*/_react.default.createElement(_formFields.TextField, {
    variant: "outlined",
    required: true,
    fullWidth: true,
    id: "lastName",
    label: "Last Name",
    name: "last_name",
    autoComplete: "lname",
    validate: (0, _formValidators.required)()
  })), /*#__PURE__*/_react.default.createElement(_core.Grid, {
    item: true,
    xs: 12
  }, /*#__PURE__*/_react.default.createElement(_formFields.TextField, {
    variant: "outlined",
    required: true,
    fullWidth: true,
    id: "email",
    label: "Email Address",
    name: "email",
    autoComplete: "email",
    validate: (0, _formValidators.validators)([(0, _formValidators.required)(), (0, _formValidators.email)()])
  })), !_lodash.default.includes(props.excludeFields, 'phone') && /*#__PURE__*/_react.default.createElement(_core.Grid, {
    item: true,
    xs: 12
  }, /*#__PURE__*/_react.default.createElement(_formFields.PhoneNumber, {
    placeholder: "T\xE9l\xE9phone *",
    name: "phone",
    required: true,
    country: _config.DEFAULT_PHONE_COUNTRY,
    disableAreaCodes: true,
    validate: (0, _formValidators.required)(),
    fullWidth: true
  })), /*#__PURE__*/_react.default.createElement(_core.Grid, {
    item: true,
    xs: 12,
    md: 6
  }, /*#__PURE__*/_react.default.createElement(_formFields.TextField, {
    variant: "outlined",
    required: true,
    fullWidth: true,
    name: "password",
    label: "Password",
    type: "password",
    id: "password",
    autoComplete: "current-password",
    validate: (0, _formValidators.validators)([(0, _formValidators.required)(), (0, _formValidators.min)(6, 'Le mot de passe doit contenir au moins 6 caractères')])
  })), /*#__PURE__*/_react.default.createElement(_core.Grid, {
    item: true,
    xs: 12,
    md: 6
  }, /*#__PURE__*/_react.default.createElement(_formFields.TextField, {
    variant: "outlined",
    required: true,
    fullWidth: true,
    name: "confirm_password",
    label: "Confirm Password",
    type: "password",
    id: "confirm_password",
    validate: (0, _formValidators.validators)([(0, _formValidators.required)(), (0, _formValidators.min)(6, 'Le mot de passe doit contenir au moins 6 caractères'), (0, _formValidators.equal)(props.values.password, 'Les mots de passe doivent être identiques')])
  }))))];
  formExtraFields.push( /*#__PURE__*/_react.default.createElement(_core.Grid, {
    container: true,
    spacing: 2,
    style: {
      marginTop: 16
    }
  }, /*#__PURE__*/_react.default.createElement(_core.Grid, {
    item: true,
    xs: _config.SHOW_USER_CONDITIONS ? 10 : 12
  }, /*#__PURE__*/_react.default.createElement(_formFields.Checkbox, {
    name: "accept",
    required: true,
    label: "J'accepte les conditions d'utilisations",
    validate: (0, _formValidators.validators)([(0, _formValidators.required)(), (0, _formValidators.accept)()])
  })), _config.SHOW_USER_CONDITIONS && /*#__PURE__*/_react.default.createElement(_core.Grid, {
    container: true,
    item: true,
    xs: 2,
    alignItems: "center"
  }, /*#__PURE__*/_react.default.createElement("a", {
    target: "_blank",
    href: "".concat(_config.BASE_URL).concat(props.intl.formatMessage({
      id: 'cgu_url',
      defaultMessage: 'cgu_url'
    }))
  }, /*#__PURE__*/_react.default.createElement(_Translations.IntlMessages, {
    id: "CGU"
  })))));
  {
    SocialAuthButtons && formExtraFields.push( /*#__PURE__*/_react.default.createElement(SocialAuthButtons, props));
  }
  formExtraFields.push( /*#__PURE__*/_react.default.createElement(_core.Grid, {
    container: true,
    spacing: 0,
    alignItems: "center"
  }, /*#__PURE__*/_react.default.createElement(_core.Grid, {
    container: true,
    className: "mt-10",
    justify: "center"
  }, /*#__PURE__*/_react.default.createElement(_core.Grid, {
    item: true,
    xs: 10,
    md: 8,
    style: {
      marginLeft: 10,
      marginRight: 10
    }
  }, /*#__PURE__*/_react.default.createElement(_Button.default, {
    onClick: props.handleSubmit,
    disabled: props.inProgress,
    type: "submit",
    fullWidth: true,
    variant: "contained",
    color: "primary"
  }, /*#__PURE__*/_react.default.createElement(_Translations.IntlMessages, {
    id: "Sign Up",
    defaultMessage: "Sign Up"
  }))), /*#__PURE__*/_react.default.createElement(_core.Grid, {
    container: true,
    justify: "center",
    className: "mt-4"
  }, /*#__PURE__*/_react.default.createElement(_core.Grid, {
    item: true
  }, /*#__PURE__*/_react.default.createElement(_Translations.IntlMessages, {
    id: "Vous avez d\xE9j\xE0 un compte?"
  }), /*#__PURE__*/_react.default.createElement(_reactRouterDom.Link, {
    to: "/login",
    variant: "body2",
    className: "ml-2"
  }, /*#__PURE__*/_react.default.createElement(_Translations.IntlMessages, {
    id: "Connexion",
    defaultMessage: "Connexion"
  })))))));
  return formExtraFields;
};
function buildInjectToForm() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    _ref$form = _ref.form,
    form = _ref$form === void 0 ? _BaseForm.default : _ref$form,
    _ref$formExtraFields = _ref.formExtraFields,
    formExtraFields = _ref$formExtraFields === void 0 ? function (props) {
      return getFormExtraFields(props);
    } : _ref$formExtraFields;
  return (0, _BaseInjectors.injectToForm)(form, {
    formExtraFields: formExtraFields,
    handleInitialValues: function handleInitialValues(props) {
      var initialValues = {
        first_name: '',
        last_name: '',
        email: '',
        password: '',
        accept: '',
        confirm_password: '',
        phone: ''
      };
      _lodash.default.forEach(props.excludeFields, function (fieldName) {
        if (_lodash.default.has(initialValues, fieldName)) {
          delete initialValues[fieldName];
        }
      });
      return initialValues;
    }
  });
}
var _default = buildInjectToForm();
exports.default = _default;